import { createCodeBlockPlugin } from '@sketchnote/slate-plugins';
import { PlateProvider } from '@udecode/plate';
import {
  createBlockquotePlugin,
  createBoldPlugin,
  createCodePlugin,
  createComboboxPlugin,
  createHeadingPlugin,
  createItalicPlugin,
  createMentionPlugin,
  createParagraphPlugin,
  createPlateUI,
  createPlugins,
  createStrikethroughPlugin,
  createUnderlinePlugin,
  ELEMENT_MENTION,
  MentionElement,
  withProps,
} from '@udecode/plate';
import { useMemo } from 'react';

export const MinimalEditorProvider = ({
  id,
  children,
}: {
  id: string;
  children: React.ReactNode;
}) => {
  const plugins = [
    createParagraphPlugin(),
    createBlockquotePlugin(),
    createCodeBlockPlugin(),
    createHeadingPlugin(),
    createBoldPlugin(),
    createItalicPlugin(),
    createUnderlinePlugin(),
    createStrikethroughPlugin(),
    createCodePlugin(),
    createComboboxPlugin(),
    createMentionPlugin({
      options: {
        trigger: '@',
        insertSpaceAfterMention: true,
        createMentionNode: (item: any) => {
          return { data: item.data, value: '' };
        },
      },
    }),
  ];
  const renderLabel = (mentionable) => {
    return `@${mentionable.name || mentionable?.data?.name}`;
  };

  const components = createPlateUI({
    [ELEMENT_MENTION]: withProps(MentionElement, {
      renderLabel: renderLabel,
      styles: {
        root: {
          marginTop: '0.5rem',
          marginBottom: '0.5rem',
          boxShadow: 'none',
          backgroundColor: 'inherit',
          color: '#254DDA',
        },
      },
    }),
  });
  const pluginsMemo = useMemo(() => {
    return createPlugins([...plugins], { components });
  }, []);

  return (
    <PlateProvider plugins={pluginsMemo} id={id}>
      {children}
    </PlateProvider>
  );
};
